import { Turbo } from "@hotwired/turbo-rails";

import updateAssociations from "../../backoffice/services/externalPositionsService/updateAssociations";
import removeAssociations from "../../backoffice/services/externalPositionsService/removeAssociations";

export default {
  addLoadingOverlay(targetElement) {
    const customEvent = new CustomEvent("turbo-frame-loading:start", {
      detail: {
        targetElement,
        identifier: "loading-overlay",
      },
    });

    window.dispatchEvent(customEvent);
  },

  removeLoadingOverlay(targetElement) {
    const customEvent = new CustomEvent("turbo-frame-loading:stop", {
      detail: {
        targetElement,
        identifier: "loading-overlay",
      },
    });

    window.dispatchEvent(customEvent);
  },

  updateUI() {
    Turbo.visit(window.location.href, {
      frame: "external_positions",
    });

    return Turbo.visit(window.location.href, {
      frame: "booking_resource_skus",
    });
  },

  handleAssociation(
    draggedData,
    targetData,
    transferDirection = null,
    flightData = null
  ) {
    const associations = {
      transfer: () => {
        this.createTransferParentChildAssociation(draggedData, targetData);
      },
      flight: () => {
        this.createTransferFlightAssociation(
          draggedData,
          targetData,
          transferDirection,
          {
            externalPositionFlightId: flightData?.externalPositionFlightId,
          }
        );
      },
    };

    associations[draggedData.type]();
  },

  createTransferFlightAssociation(
    draggedData,
    targetData,
    transferDirection,
    flightData
  ) {
    const transferBookingResourceSkuId = targetData.id;
    const externalPositionId = draggedData.id;
    const externalPositionFlightId = flightData?.externalPositionFlightId;

    if (!externalPositionFlightId || !transferDirection) {
      return;
    }

    this.createTransferAssociation(
      transferBookingResourceSkuId,
      externalPositionId,
      "flight",
      draggedData,
      targetData,
      transferDirection,
      { externalPositionFlightId }
    );
  },

  createTransferParentChildAssociation(draggedData, targetData) {
    let bookingResourceSkuId = null;

    if (draggedData.associatedBookingResourceSkuIdFromInverse) {
      bookingResourceSkuId =
        draggedData.associatedBookingResourceSkuIdFromInverse;
    } else {
      bookingResourceSkuId = targetData.id;
    }
    const associatedBookingResourceSkuId = draggedData.id;

    this.createTransferAssociation(
      bookingResourceSkuId,
      associatedBookingResourceSkuId,
      "parent_child",
      draggedData,
      targetData
    );
  },

  createTransferAssociation(
    transferBookingResourceSkuId,
    externalPositionId,
    associationType,
    draggedData,
    targetData,
    transferDirection = null,
    flightData = null
  ) {
    this.addLoadingOverlay(targetData.element);

    const payload = {
      transferBookingResourceSkuId,
      externalPositionId,
      associationType,
      transferDirection,
      externalPositionFlightId: flightData?.externalPositionFlightId,
    };

    updateAssociations({
      ...payload,
      success: async () => {
        try {
          await this.updateUI();
          const successEvent = new CustomEvent("turbo-frame-loading:start", {
            detail: {
              targetElement: targetData.element,
              identifier: "success-indicator",
              hideAfter: 1500,
            },
          });
          window.dispatchEvent(successEvent);
        } finally {
          this.removeLoadingOverlay(targetData.element);
        }
      },
      error: async () => {
        if (draggedData?.event?.from && draggedData.element) {
          draggedData.event.from.appendChild(draggedData.element);
        }
        await this.updateUI();
        this.removeLoadingOverlay(targetData.element);
      },
    });
  },

  breakRelationship(event) {
    const { transferBookingResourceSkuId } = event.currentTarget.dataset;

    const targetElement = event.currentTarget.closest(
      "[data-resource-sku-handle]"
    );

    this.addLoadingOverlay(targetElement);

    removeAssociations({
      transferBookingResourceSkuId,
      success: async () => {
        await this.updateUI();
        this.removeLoadingOverlay(targetElement);
      },
      error: async () => {
        await this.updateUI();
        this.removeLoadingOverlay(targetElement);
      },
    });
  },
};
